module.exports = __webpack_public_path__ + "static/images/hero.46219464ec3bb87c26f5a6f9acb03805.jpg";